import React from "react";

import { Container, Content, Info } from "./styles";

import Button from "@material-ui/core/Button";

function DownloadBoletoView() {
  return (
    <Container>
      <Content>
        <p>
          <strong>Falta Só mais um passo Marco!</strong>
        </p>
        <p>Clique no botão abaixo para <br />
        baixar o boleto e efetuar o <br />
        pagamento <br /> </p>
        <Button variant="contained" color="primary">
          Baixar Boleto
        </Button>
        <Info>Nós também enviamos o boleto no seu e-mail</Info>
      </Content>
    </Container>
  );
}

export default DownloadBoletoView;
